<template>
    <div id="FooterBannerSection">
      <v-container class="p-0" fluid>
        <v-row no-gutters>
          <v-col cols="12">
            <div class="box" v-inview:animate="'fadeIn'">
              <carousel
                :autoplay="true"
                :loop="true"
                :mouse-drag="true"
                :per-page="1"
                :paginationEnabled="false"
                :autoplayTimeout="4000"
                @pageChange="pageChange">
                <slide class="talk"
                       :key="index"
                       :index="index"
                       v-for="(question, index) in questions">
                  <div class="question">
                    <div class="top">
                      <div class="profile">
                        <img class="b-img" :src="require('@/assets/images/marketing/' + question.img)"/>
                      </div>
                    </div>
                    <div class="bottom">
                      <div class="content" v-line-clamp="7"
                           v-html="question.content">
                      </div>
                    </div>
                  </div>
                </slide>
              </carousel>
              <div class="dots-section">
                <ul class="dots">
                  <li :class="{'active': index==currentSlide}"
                      :key="index" class="dot"
                      v-for="(question, index) in questions"
                  ></li>
                </ul>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
  </div>
</template>
<script>
export default {
  name: 'FooterBannerSection',
  components: {
  },
  data() {
    return {
      currentSlide: 0,
      number: 800,
      questions: [
        {
          img: '2.jpg',
          content: '<b>호반으로부터 김** 사장님</b><br/><br/>음료쿠폰을 카톡으로 보냈더니 재방문 고객이 많이 늘었어요. 음료수 한병으로 두번, 세번 방문을 유도할 수 있다는게 너무 신기하더라구요!',
        },
        {
          img: '3.jpg',
          content: '<b>포항 쉼터 이** 사장님</b><br/><br/>퇴직 후 동네에서 조그만 호프집을 운영하고 있어요.마케팅 경험도 없고 동네 장사라 신경쓰지 못했는데  저 대신 단골손님에게 문자를 보내주시니 손님들이 가게에 오실 때 더 친근하게 다가와 주셨어요.내 가게를 잊혀지지 않도록 관리해주는 게 너무 좋아요.',
        },
        {
          img: '1.png',
          content: '<b>라떼는말이야 정** 사장님</b><br/><br/>그동안 단골분들을 어떻게 관리해야하나..고민했는데  카카오톡을 이용해서 관리하니까 메세지를 얼마나 봤는지, 쿠폰을 얼마나 썼는지  바로 확인할 수 있고 쿠폰도 종이가 아닌 메세지로 가서 관리도 쉽고 고객분들도 좋아하는 거 같아요',
        },
      ]
    }
  },
  methods: {
    pageChange(data) {
      this.currentSlide = data
    }
  }
}
</script>
<style lang="scss" scoped>
  #FooterBannerSection {
    background-color: #fcfbf9;
    padding-top: 6vh;
    padding-left: 2.82vw;
    padding-right: 2.82vw;
    padding-bottom: 20vh;
    .description {
      text-align: center;
      font-size: 0.94rem;
      letter-spacing: -0.19px;
      font-weight: 600;
    }
    .box {
      // box-sizing: border-box;
      // width: 100%;
      display: block;
      float: left;
      position: relative;
      border-radius: 12px;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      margin-top: 13px;
      @media screen and (max-width: 350px) {
        padding: 24px 21px;
      }
      @media screen and (min-width: 350px) {
        padding: 24px 24px;
      }

      .talk {
        width: 100%;
      }
      .top {
        width: 70px;
        height: 70px;
        float: top;
        text-align: center;
        position: relative; left: 50%; transform: translateX(-50%);
        margin-right: 10px;
      }
      .bottom {
        width: calc(100%);
        float: bottom;
      }
      .question {
        width: 100%;
        position: relative;
        display: block;
        float: left;
        .profile {
          img {
            width: 100%;
            height: 60px;
            border-radius: 100%;
            border-width: 0;
            background-color: #f6f6f6;
          }
        }
        .content {
          width: 600px;
          font-weight: 600;
          line-height: 1.3;
          height: 10em;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          @media screen and (max-width: 350px) {
            font-size: 13px;
          }
          @media screen and (min-width: 350px) {
            font-size: 15px;
          }
        }
      }
      .dots {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        list-style-type: none;
        margin: 15px 0 0 0;
        padding: 0;
        .dot {
          width: 8px;
          height: 8px;
          margin: 0px 3px;
          background-color: #d7e1ea;
          border-radius: 100%;
          &.active {
            background-color: #1baaf1;
          }
        }
      }
    }
  }
  #Banner {
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
  }
</style>
